<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <button
          type="button"
          id="btnToevoegen"
          class="btn btn-primary btn-xs"
          @click.prevent="btnToevoegen"
          v-if="btnToevoegenVisible"
        >
          <font-awesome-icon icon="plus" />
          {{ translation(2276) }}
        </button>
        <!-- share Button waarmee je naar delenactiviteiten pagina -->
        <button
          type="button"
          id="btnShare"
          class="btn btn-default btn-xs HideForMobileApp"
          @click.prevent="btnShare"
          v-if="activitySettings.overzichtActiviteit"
        >
          <font-awesome-icon icon="share-alt" />
          {{ translation(14450) }}
        </button>

        <!-- terug Button waarbij je terug naar overzicht activiteiten gaat -->
        <button
          type="button"
          id="btnTerug"
          class="btn btn-primary btn-xs"
          @click.prevent="btnTerug"
          v-if="activitySettings.delenActiviteit"
        >
          <font-awesome-icon icon="chevron-left" />
          {{ translation(14449) }}
        </button>
      </template>
    </XVactionbar>
    <div v-if="waiter === true">
      <XVwaiter></XVwaiter>
    </div>
    <div v-if="waiter === false">
      <!-- Titel word getoond adhv van prop activitySettings.overzichtActiviteit. Bij true tonen, anders niet tonen  -->
      <div class="row" v-if="activitySettings.overzichtActiviteit">
        <div class="col-md-12">
          <span id="lblTitel1" class="titel">{{ labels.lbltitle }}</span>
        </div>
      </div>
      <!-- Titel "Delen activiteit" word getoond adhv van prop activitySettings.delenActiviteit. Bij true tonen, anders niet tonen  -->
      <div class="row" v-if="activitySettings.delenActiviteit">
        <div class="col-md-12">
          <span id="lblTitel2" class="titel">{{ translation(14453) }}</span>
        </div>
      </div>
      <!-- De hyperlinks tonen adhv van prop activitySettings.overzichtActiviteit. Bij true tonen, anders niet tonen. Ook checken of de link aanezig is.  -->
      <div
        id="pnlTabLinksDossier"
        class="pnlInfoActiviteit tabLinksDossier"
        v-if="activitySettings.overzichtActiviteit"
      >
        <template id="beheertabs" v-if="role === 'beheer'">
          <div class="row visibileTab0adm" v-if="settings.hypProfDetail_NavigateUrl != null">
            <div class="col-md-12">
              <!-- hypProfDetail alleen tonen als hij gevuld is -->
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a :href="settings.hypProfDetail_NavigateUrl">{{ translation(334) }}</a>
            </div>
          </div>
          <div class="row visibileTabProfMsgadm" v-if="settings.hypProfMsg_NavigateUrl != null">
            <div class="col-md-12">
              <!-- hypProfMsg alleen tonen als hij gevuld is -->
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a :href="settings.hypProfMsg_NavigateUrl">{{ translation(12339) }}</a>
            </div>
          </div>
          <div class="row visibileTab1adm" v-if="settings.hypStatusoverzicht_NavigateUrl != null">
            <div class="col-md-12">
              <!-- hypStatusoverzicht alleen tonen als hij gevuld is -->
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a :href="settings.hypStatusoverzicht_NavigateUrl">{{ translation(2258) }}</a>
            </div>
          </div>
          <div class="row visibileTab2adm" v-if="labels.lblActiviteiten != null && (settings.hypProfDetail_NavigateUrl != null || settings.hypProfMsg_NavigateUrl != null || settings.hypStatusoverzicht_NavigateUrl != null || settings.hypMutatie_NavigateUrl != null || settings.hypMSF_NavigateUrl != null)">
            <div class="col-md-12">
              <font-awesome-icon :icon="['fa', 'location-arrow']" class="fa-rotate-45" />
              &nbsp;&nbsp;{{ labels.lblActiviteiten }}
            </div>
          </div>
          <div class="row visibileTab3adm" v-if="settings.hypMutatie_NavigateUrl != null">
            <div class="col-md-12">
              <!-- hypMutatie alleen tonen als hij gevuld is -->
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a :href="settings.hypMutatie_NavigateUrl">{{ translation(2260) }}</a>
            </div>
          </div>
          <div class="row visibileTab4adm" v-if="settings.hypMSF_NavigateUrl != null">
            <div class="col-md-12">
              <!-- hypMSF alleen tonen als hij gevuld is -->
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a :href="settings.hypMSF_NavigateUrl">{{ translation(10367) }}</a>
            </div>
          </div>
        </template>
        <template id="proftabs" v-if="role === 'prof'">
          <div class="row visibileTab1" v-if="settings.hypStatusoverzicht_NavigateUrl != null">
            <div class="col-md-12">
              <!-- hypStatusoverzicht -->
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a :href="settings.hypStatusoverzicht_NavigateUrl">{{ translation(2258) }}</a>
            </div>
          </div>
          <div class="row visibileTab2" v-if="settings.hypStatusoverzicht_NavigateUrl != null || settings.hypMutatie_NavigateUrl != null">
            <div class="col-md-12">
              <font-awesome-icon :icon="['fa', 'location-arrow']" class="fa-rotate-45" />
              &nbsp;&nbsp;{{ labels.lblActiviteiten }}
            </div>
          </div>
          <div class="row visibileTab3" v-if="settings.hypMutatie_NavigateUrl != null">
            <div class="col-md-12">
              <!-- hypMutatie -->
              <font-awesome-icon :icon="['far', 'location-arrow']" class="fa-rotate-45" />&nbsp;&nbsp;
              <a :href="settings.hypMutatie_NavigateUrl">{{ translation(2260) }}</a>
            </div>
          </div>
        </template>

        <div class="row lblinfo" v-if="role === 'beheer'">
          <div class="col-md-12">
            <p v-html="labels.lblBeroepsgroep"></p>
          </div>
        </div>
        <div class="row lblinfo">
          <div class="col-md-12">
            <p v-html="labels.lblBeschrijving"></p>
          </div>
        </div>
      </div>
      <XVgraphcontrol
        :graphdata="graphdata"
        @graphClick="graphClick"
        v-if="activitySettings.overzichtActiviteit"
      ></XVgraphcontrol>
      <!-- beschrijving en select box word getoond adhv van prop activitySettings.delenActiviteit. Bij true tonen, anders niet tonen  -->
      <div class="pnlInfoDelen" v-if="activitySettings.delenActiviteit">
        <div class="row">
          <div class="col-md-12">
            <span v-html="translation(14454)"></span>
          </div>
        </div>

        <!-- PDF -->
        <div class="row btnsharepdf" :class="{ DisabledItem: btnPdfDisable }">
          <div class="col-md-12 margin20">
            <font-awesome-layers class="fa-2x fastackmargin">
              <font-awesome-icon :icon="['fal', 'file-pdf']" class="graphicon" /> </font-awesome-layers
            >&nbsp;
            <span @click="downloadPdf()" class="fakelink graphUrl">{{ translation(14451) }}</span>
          </div>
          <div class="margin10"></div>
        </div>
        <!-- END PDF -->

        <!-- Excel -->
        <div class="row btnshareExcel" :class="{ DisabledItem: btnExcelDisable }">
          <div class="col-md-12 margin20">
            <downloadexcel
              :fetch="fetchData"
              :fields="json_fields"
              :before-generate="startDownload"
              :before-finish="finishDownload"
              type="xls"
              name="Activities.xls"
            >
              <font-awesome-layers class="fa-2x fastackmargin">
                <font-awesome-icon :icon="['fal', 'file-excel']" class="graphicon" /> </font-awesome-layers
              >&nbsp;
              <span class="fakelink graphUrl">{{ translation(14452) }}</span>
            </downloadexcel>
          </div>
          <div class="margin10"></div>
        </div>

        <!-- END Excel -->

        <div class="row checkboxclass margin20">
          <div class="col-md-12">
            <XVcheckbox
              style="margin: 7px"
              @click="toggleSelect()"
              v-model="activitySettings.toggleSelectAllValue"
              id="cbSelectAll"
            ></XVcheckbox>
            {{ translation(14455) }}
          </div>
        </div>
      </div>

      <div class="row margin20" v-show="activitySettings.overzichtActiviteit">
        <div class="col-md-12">
          <!-- Zoekfilters tonen adhv van prop activitySettings.overzichtActiviteit. Bij true tonen, anders niet tonen  -->
          <XVfilter>
            <div slot="content">
              <div class="row margin20">
                <div class="col-md-4">
                  <label>{{ translation(8893) }}</label>
                </div>
                <div class="col-md-8">
                  <label>{{ translation(56) }}</label>
                </div>
              </div>
              <div class="row">
                <div
                  class="offset-md-4 col-md-8 form-group has-feedback"
                  v-bind:class="{ 'form-group--error': errors.has('tbxVanDiv') }"
                >
                  <XVdate
                    id="tbxVanDiv"
                    key="tbxVanDiv"
                    name="tbxVanDiv"
                    :data-vv-as="translation(56)"
                    v-validate="{ XVDateDefault: true }"
                    v-model="activitySettings.istartdate"
                    @input="valVanDiv"
                  ></XVdate>
                  <span class="form-group__message">{{ errors.first('tbxVanDiv') }}</span>
                </div>
              </div>
              <div class="row">
                <div class="offset-md-4 col-md-8">
                  <!-- lblTot -->
                  <label>{{ translation(9162) }}</label>
                </div>
              </div>
              <div class="row">
                <div
                  class="offset-md-4 col-md-8 form-group has-feedback"
                  v-bind:class="{
                    'form-group--error':
                      errors.has('tbxTotDiv') || isAfter(activitySettings.istartdate, activitySettings.ienddate)
                  }"
                >
                  <XVdate
                    id="tbxTotDiv"
                    key="tbxTotDiv"
                    name="tbxTotDiv"
                    :data-vv-as="translation(9162)"
                    v-validate="{ XVDateDefault: true }"
                    v-model="activitySettings.ienddate"
                    @input="valTotDiv"
                  ></XVdate>
                  <span class="form-group__message">{{ errors.first('tbxTotDiv') }}</span>
                  <span
                    class="form-group__message"
                    v-if="isAfter(activitySettings.istartdate, activitySettings.ienddate)"
                    >{{ translation(9162) }} {{ translation(14377) }} {{ translation(56) }}</span
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label>{{ translation(8915) }}</label>
                </div>
                <div class="col-md-8 form-group has-feedback">
                  <multiselect
                    :placeholder="translation(15450)"
                    v-model="activitySettings.multiselected"
                    @input="multiselectInput"
                    @close="multiselectClose"
                    :options="categorielist"
                    :multiple="true"
                    :close-on-select="multiCloseOnSelect"
                    :clear-on-select="false"
                    :hide-selected="true"
                    :preserve-search="true"
                    :searchable="multiSearchable"
                    selectLabel
                    label="categoryname"
                    track-by="categoryname"
                    :preselect-first="true"
                    :maxHeight="200"
                    openDirection="bottom"
                  >
                    <template slot="tag" slot-scope="props">
                      <span class="multiselect__tag">
                        <span>{{ props.option.categoryname }}</span>
                        <i
                          aria-hidden="true"
                          tabindex="1"
                          class="multiselect__tag-icon"
                          @click="props.remove(props.option)"
                        ></i>
                      </span>
                    </template>
                    <span slot="noResult">{{ translation(14508) }}</span>
                  </multiselect>
                </div>
              </div>
              <XVbootstraprow
                :label="translation(15987)"
                id="tbxOmschrijving"
                v-if="activitySettings.tbxOmschrijvingVisible"
              >
                <XVinput
                  id="tbxOmschrijving"
                  key="tbxOmschrijving"
                  name="tbxOmschrijving"
                  v-model="activitySettings.tbxOmschrijving"
                  type="text"
                ></XVinput>
              </XVbootstraprow>
            </div>
            <span slot="filterbuttons">
              <div v-if="!activitySettings.btnwis">
                <button
                  id="btnFilter2"
                  :disabled="errors.items.length > 0"
                  @click="activitySettings.btnwis = true"
                  class="btn btn-primary XVSearchbarButton"
                  @click.prevent="tablefilter()"
                >
                  {{ translation(5494) }}
                  <font-awesome-icon icon="filter" />
                </button>
              </div>
              <div v-if="activitySettings.btnwis">
                <div class="btn-group XVSearchbarFilter">
                  <button
                    id="activitySettings.btnwis"
                    class="btn btn-primary XVSearchbarButton"
                    @click.prevent="clearfilter()"
                  >
                    {{ translation(8835) }}
                    <font-awesome-icon icon="eraser" />
                  </button>
                  <button
                    id="btnFilter"
                    :disabled="errors.items.length > 0"
                    class="btn btn-primary XVSearchbarButton"
                    @click.prevent="tablefilter()"
                  >
                    {{ translation(5494) }}
                    <font-awesome-icon icon="filter" />
                  </button>
                </div>
              </div>
            </span>
          </XVfilter>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <XVtableV2
            v-if="activitySettings.overzichtActiviteit"
            :filterfunc="filterfunc"
            :tablesetting="activityTable.tablesetting"
            :tablecolumnsetting="activityTable.tablecolumnsetting"
            :tabledata="activityTable.tabledata"
            :rowvisible="activityTable.rowvisible"
            v-on:sortXVTable="XVTablesort"
            :paging="true"
            :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
          >
            <!-- als er een link is dan deze op de column zetten, anders alleen de naam weergeven -->
            <!-- Bij statuslink checken of het een beheer is en dan of het naar de 024 gaat. In dat geval moet het een openwindow zijn in een nieuw tabblad omdat de 024 voor beheer geen terug knop heeft-->
            <template slot="tblPersonActivityDateCompleted" slot-scope="dr">
              <span v-if="dr.row.tblPersonActivityIDLink !== null">
                <a :href="'/' + dr.row.tblPersonActivityIDLink">{{ dr.celldata }}</a>
              </span>
              <span v-if="dr.row.tblPersonActivityIDLink === null">{{ dr.celldata }}</span>
            </template>
            <template slot="statustxt" slot-scope="dr">
              <span
                v-if="dr.row.statusLink !== null && role === 'beheer' && checkstring024(dr.row.statusLink) === true"
              >
                <a href="#" v-on:click="openwindow(dr.row.statusLink)">{{ dr.celldata }}</a>
              </span>
              <span
                v-if="dr.row.statusLink !== null && role === 'beheer' && checkstring024(dr.row.statusLink) === false"
              >
                <a :href="'/' + dr.row.statusLink">{{ dr.celldata }}</a>
              </span>
              <span v-if="dr.row.statusLink !== null && role === 'prof'">
                <a :href="'/' + dr.row.statusLink">{{ dr.celldata }}</a>
              </span>
              <span v-if="dr.row.statusLink === null">{{ dr.celldata }}</span>
            </template>

            <template slot="tblPersonPEActivityPEPoints" slot-scope="dr">{{ formatpoints(dr.celldata) }}</template>
          </XVtableV2>

          <XVtableV2
            v-if="activitySettings.delenActiviteitXVtableshow"
            :filterfunc="filterfunc"
            :tablesetting="activityTable.tablesetting"
            :tablecolumnsetting="activityTable.tablecolumnsetting"
            :tabledata="activityTable.tabledata"
            :rowvisible="activityTable.rowvisible"
            v-model="activitySettings.tableview"
            v-on:sortXVTable="XVTablesort"
            :paging="activitySettings.paging"
            :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
          >
            <!-- als er chckbox is dan deze tonen. Dit is bij activitySettings.delenActiviteit -->
            <template slot="tblPersonPEActivityCheckbox" slot-scope="dr">
              <XVcheckbox
                v-model="activitySettings.shareSelected[dr.rowcountindex]"
                @click="rowselected()"
                :value="dr.index"
                type="checkbox"
                :id="'checkbox' + dr.index"
                style="text-align: center"
              />
            </template>
            <template slot="tblPersonPEActivityPEPoints" slot-scope="dr">{{ formatpoints(dr.celldata) }}</template>
          </XVtableV2>

          <!-- PDF -->
          <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="800"
            :pdf-quality="2"
            pdf-format="a4"
            pdf-orientation="landscape"
            pdf-content-width="1080px"
            :manual-pagination="false"
            :html-to-pdf-options="htmlToPdfOptions"
            @beforeDownload="beforeDownload($event)"
            @hasDownloaded="hasDownloaded($event)"
            ref="html2Pdf"
          >
            <section slot="pdf-content">
              <div id="pdf-logo"></div>
              <div id="pdf-name">
                {{ userInfo.currentUser }}
              </div>
              <div id="pdf-date">{{ translation(19579) + ' ' + activitySettings.dateToday }}</div>
              <XVtableV2
                v-if="activitySettings.delenActiviteitXVtableshow"
                :tablesetting="activityTable.tablesetting"
                :tablecolumnsetting="tableColumnsWithoutSelectBox"
                :tabledata="selectedTableData"
                :rowvisible="activityTable.rowvisible"
                v-on:sortXVTable="XVTablesort"
                :paging="activitySettings.paging"
                :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
              >
                <template slot="tblPersonPEActivityPEPoints" slot-scope="dr">{{ formatpoints(dr.celldata) }}</template>
              </XVtableV2>
            </section>
          </vue-html2pdf>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SPE021PEActiviteiten from './SPE021PEActiviteiten'
export default SPE021PEActiviteiten
</script>

<style></style>
